<template>
  <div class="emojiContainer">
    <div class="emoji" v-for="emoji in allEmojis" :key="emoji">
      <img @click="handleClick(emoji)" class="emojiPic" :src="require(`../../assets/emojis/${emoji}-40.png`)" :alt="`${emoji}`" />
      <p :class="`${emoji} text-capitalize`">{{ emoji }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return { allEmojis: ["like", "embrace", "happy", "angry", "emotional"] }
  },
  props: { handleClick: Function },
}
</script>

<style lang="scss" scoped>
.emojiPic {
  width: 40px;
  height: 40px;
}
.angry {
  margin-left: -2.5px;
}
.embrace {
  margin-left: -8px;
}
.emotional {
  margin-left: -12.5px;
}
.emojiContainer {
  display: flex;
  padding: 8px;
  gap: 10px;
  background: #ffffff;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  transition: all 0.5s;
  position: relative;
  width: max-content;
  .emoji {
    padding: 0;
  }
  img:hover {
    cursor: pointer;
    filter: drop-shadow(0 1px 5px grey);
    transform: translateY(-10%) scale(1.2);
  }
  p {
    position: absolute;
    top: -30px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #ffffff !important;
    padding: 2px 8px;
    background: #0f1734;
    border-radius: 12px;
    visibility: hidden;
    opacity: 0;
    transition: all 0.5s;
  }
  .emojiPic:hover ~ p {
    visibility: visible;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/EmojiReactions.vue